<template>
  <div id="medium">
    <match
      v-for="(match, index) in matches"
      :key="index"
      :match="match"
    />
  </div>
</template>

<script>
import { each, find, orderBy } from 'lodash';
import Match from './Match.vue';

export default {
  name: 'Medium',
  components: {
    Match,
  },
  data() {
    return {
      maxMediumMatchesCount: 5,
      maxRows: 19,
    };
  },
  computed: {
    matches() {
      const matches = [];

      let loop = true;
      const sports = this.$store.getters.activeSports;
      each(sports, (sport) => {
        if (!loop) return;

        const sportMatches = this.$store.getters.getSportMatches(sport.id);

        each(sportMatches, (sportMatch) => {
          if (matches.length >= this.maxMediumMatchesCount) {
            loop = false;
            return;
          }
          matches.push(Object.assign({}, sportMatch, { positionSport: sport.position }));
        });
      });

      return orderBy(matches, ['position', 'positionSport', 'positionCategory', 'startAt', 'positionTournament'], ['asc', 'asc', 'asc', 'asc', 'asc']);
    },
    standardSport() {
      let standardSport;
      const matchIds = [];

      let loop = true;
      const sports = this.$store.getters.activeSports;
      each(sports, (sport) => {
        if (!loop) return;

        const sportMatchIds = this.$store.getters.getSportMatchIds(sport.id);
        each(sportMatchIds, (sportMatchId) => {
          const matchExists = find(this.matches, match => match.id === sportMatchId);
          if (!matchExists && matchIds.length < 2) {
            matchIds.push(sportMatchId);
          }
        });

        if (matchIds.length > 0) {
          loop = false;
          this.$store.dispatch('setSportMatches', { idSport: sport.id, matchIds });
          standardSport = sport;
        }
      });

      return standardSport;
    },
  },
};
</script>
